import React, { FunctionComponent, KeyboardEvent } from 'react'
import { cn } from 'ethcss'
import { Tab } from 'molecules/Tab'
import { ITabListProps } from './TabList-types'
import { tabListStyles } from './TabList-styles'

export const TabList: FunctionComponent<ITabListProps> = ({
    tabs,
    activeTab,
    ariaLabel,
    className,
    tabClassName,
    onChange,
}) => {
    const enabledTabs = tabs.filter((tab) => !tab.disabled)

    const onKeyDown = (event: KeyboardEvent<HTMLButtonElement>, id: string) => {
        const currentIndex = enabledTabs.findIndex((tab) => tab.id === id)

        if (currentIndex === -1) return

        let nextIndex = currentIndex

        switch (event.key) {
            case 'ArrowRight':
                nextIndex = (currentIndex + 1) % enabledTabs.length
                break
            case 'ArrowLeft':
                nextIndex = (currentIndex - 1 + enabledTabs.length) % enabledTabs.length
                break
            case 'Home':
                nextIndex = 0
                break
            case 'End':
                nextIndex = enabledTabs.length - 1
                break
            default:
                return
        }

        event.preventDefault()
        const nextTabId = enabledTabs[nextIndex].id

        onChange(nextTabId)
        window.requestAnimationFrame(() => document.getElementById(`tab-${nextTabId}`)?.focus())
    }

    return (
        <div role="tablist" aria-label={ariaLabel} className={cn(tabListStyles.list, className)}>
            {tabs.map((tab) => (
                <Tab
                    key={tab.id}
                    id={tab.id}
                    label={tab.label}
                    selected={activeTab === tab.id}
                    disabled={tab.disabled}
                    controls={tab.controls}
                    className={tabClassName}
                    onSelect={onChange}
                    onKeyDown={onKeyDown}
                />
            ))}
        </div>
    )
}
